import { Injectable } from '@angular/core';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthStaffGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const url: string = state.url;
        return this.checkLogin(url);
    }

    checkLogin(url: string): boolean {
        const isStaff =
            this.authService.can('manager') ||
            this.authService.can('analyst') ||
            this.authService.can('supervisor') ||
            this.authService.can('wfm_manager') ||
            this.authService.can('admin') || 
            this.authService.can('superAdmin') ||
            this.authService.can('globalAdmin');
        if (this.authService.isAuthenticated() && isStaff) {
            return true;
        }

        // Store the attempted URL for redirecting
        this.authService.redirectUrl = url;

        // Navigate to the login page with extras
        this.router.navigate(['/admin/login']);
        return false;
    }
}
